import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-life-expectancy',
  templateUrl: './life-expectancy.component.html',
  styleUrls: ['./life-expectancy.component.scss']
})
export class LifeExpectancyComponent implements OnInit {

  isInfoLifeExpect: boolean;
  isLifeExpectLesserRet: boolean;
  isLifeExpectLesserRetSpouse: boolean;
  isRetirementLesserAge: boolean;

  constructor(private dialogRef: MatDialogRef<LifeExpectancyComponent>, @Inject(MAT_DIALOG_DATA) public data: string ) { 
    //console.log('dialogRef');
    //console.log(data);
    if (data == 'info-life-expectancy') {
      this.isInfoLifeExpect = true;
    } else if (data == 'life-expect-lesser-retirement') {
      this.isLifeExpectLesserRet = true;
    } else if (data == 'life-expect-lesser-retirement-spouse') {
      this.isLifeExpectLesserRetSpouse = true;
    } else  {
      this.isRetirementLesserAge = true;
    }
  }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }

}
